import { ListScheduledQueriesParams } from '@api/api/scheduled-queries';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  getScheduledQuery,
  listScheduledQueries,
  listScheduledQueryConversations,
} from '@terminal/views/alfred/research/services/scheduled-query-service';

export const QUERY_KEY_SCHEDULED_QUERIES = 'QUERY_KEY_SCHEDULED_QUERIES';
export const QUERY_KEY_SCHEDULED_QUERY = 'QUERY_KEY_SCHEDULED_QUERY';
export const QUERY_KEY_SCHEDULED_QUERY_CONVERSATIONS =
  'QUERY_KEY_SCHEDULED_QUERY_CONVERSATIONS';

export const useListScheduledQueries = (
  params: ListScheduledQueriesParams = {}
) =>
  useQuery({
    queryKey: [QUERY_KEY_SCHEDULED_QUERIES, params],
    queryFn: () => listScheduledQueries(params),
  });

export const useGetScheduledQuery = (id: string, enabled = true) =>
  useQuery({
    queryKey: [QUERY_KEY_SCHEDULED_QUERY, id],
    queryFn: () => getScheduledQuery(id),
    enabled: !!id && enabled,
  });

export const useListScheduledQueryConversations = (
  id: string,
  params: { page?: number; page_size?: number } = {},
  enabled = true
) =>
  useQuery({
    queryKey: [QUERY_KEY_SCHEDULED_QUERY_CONVERSATIONS, id, params],
    queryFn: () => listScheduledQueryConversations(id, params),
    enabled: !!id && enabled,
    refetchOnMount: 'always',
    placeholderData: keepPreviousData,
  });
